import React from 'react'

import { LntButton, LntSpin } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import { WarningContent } from './components'

import styles from './styles.module.scss'

import type { SendPopoverContentProps } from './types'

const DEFAULT_TITLE = 'Отправить результаты в Pricing Tool?'

export const SendPopoverContent: React.FC<SendPopoverContentProps> = ({ warning, isLoading, onClose, onSubmit }) => {
  const handleSubmitFactory = (confirmSent?: boolean) => () => {
    onSubmit?.(confirmSent)
  }

  return (
    <div className={ styles.sendPopoverContent }>
      <LntSpin spinning={ isLoading }>
        <div className={ styles.sendPopoverContent__text }>
          { warning ? <WarningContent text={ warning } /> : DEFAULT_TITLE }
        </div>
      </LntSpin>

      <div className={ styles.sendPopoverContent__buttons }>
        <LntButton
          type={ BUTTON_TYPE.secondary }
          size={ SIZE.small }
          onClick={ onClose }
          disabled={ isLoading }
        >
          Нет
        </LntButton>

        <LntButton
          type={ BUTTON_TYPE.primary }
          size={ SIZE.small }
          onClick={ handleSubmitFactory(!!warning) }
          disabled={ isLoading }
        >
          Отправить
        </LntButton>
      </div>
    </div>
  )
}
